import { FamigliaDiIntervento } from 'models/FamigliaDiIntervento';
import { Pagination, PaginationResult } from 'types/pagination';
import axios from 'utils/axios';

class FamigliaDiInterventoService {
    async upsertFamigliaDiIntervento(
        tenantId: string,
        userId: string,
        username: string,
        famigliaDiIntervento: FamigliaDiIntervento
    ): Promise<boolean> {
        try {
            const res = await axios.post<boolean>('/UpsertFamigliaDiIntervento', {
                tenantId,
                userId,
                username,
                id: famigliaDiIntervento.id,
                referentIds: famigliaDiIntervento.users?.map((user) => user.userId) || []
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to upsert famiglia di intervento');
        }
    }

    async getFamiglieDiInterventoItems(tenantId: string): Promise<FamigliaDiIntervento[]> {
        try {
            const res = await axios.post<FamigliaDiIntervento[]>('/GetFamiglieDiInterventoItems', tenantId);
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch famiglie items');
        }
    }

    async getFamigliaDiIntervento(tenantId: string, id: string): Promise<FamigliaDiIntervento> {
        try {
            const res = await axios.post<FamigliaDiIntervento>('/GetFamigliaDiIntervento', { tenantId, id });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch piano di intervento ');
        }
    }

    async getFamigliaDiInterventoPaginated(
        tenantId: string,
        pagination: Pagination,
        simulazioneId: string | null
    ): Promise<PaginationResult<FamigliaDiIntervento>> {
        try {
            const res = await axios.post<PaginationResult<FamigliaDiIntervento>>('/GetFamigliaDiInterventoPaginated', {
                ...pagination,
                tenantId,
                simulazioneId
            });
            return res.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch piani di intervento');
        }
    }
}

export default FamigliaDiInterventoService;
